import React from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = 'Bevestigen',
  message,
  onConfirm,
  onCancel,
  confirmText = 'Ja, verwijderen',
  cancelText = 'Annuleren',
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal">
      <div className="modal-content">
        {title && <h2>{title}</h2>}
        <p>{message}</p>
        <div className="modal-actions">
          <button className="cancel-btn" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="confirm-btn" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
